import { render, staticRenderFns } from "./LettresAdd.vue?vue&type=template&id=073b28f7&scoped=true"
import script from "./LettresAdd.vue?vue&type=script&lang=js"
export * from "./LettresAdd.vue?vue&type=script&lang=js"
import style0 from "./LettresAdd.vue?vue&type=style&index=0&id=073b28f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073b28f7",
  null
  
)

export default component.exports